var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.797 9.04166C5.74492 8.83979 5.63969 8.65556 5.49227 8.50814C5.34485 8.36072 5.16062 8.25549 4.95875 8.20341L1.38 7.28058C1.31894 7.26325 1.2652 7.22648 1.22694 7.17584C1.18867 7.1252 1.16797 7.06347 1.16797 7C1.16797 6.93653 1.18867 6.87479 1.22694 6.82415C1.2652 6.77352 1.31894 6.73674 1.38 6.71941L4.95875 5.796C5.16055 5.74397 5.34473 5.63883 5.49215 5.49152C5.63956 5.34421 5.74483 5.1601 5.797 4.95833L6.71983 1.37958C6.73698 1.31828 6.77372 1.26428 6.82443 1.22581C6.87515 1.18734 6.93705 1.16652 7.0007 1.16652C7.06436 1.16652 7.12626 1.18734 7.17698 1.22581C7.22769 1.26428 7.26442 1.31828 7.28158 1.37958L8.20383 4.95833C8.25591 5.16021 8.36113 5.34444 8.50855 5.49186C8.65597 5.63928 8.8402 5.7445 9.04208 5.79658L12.6208 6.71883C12.6824 6.73581 12.7366 6.7725 12.7753 6.82329C12.814 6.87408 12.8349 6.93616 12.8349 7C12.8349 7.06384 12.814 7.12591 12.7753 7.1767C12.7366 7.22749 12.6824 7.26419 12.6208 7.28116L9.04208 8.20341C8.8402 8.25549 8.65597 8.36072 8.50855 8.50814C8.36113 8.65556 8.25591 8.83979 8.20383 9.04166L7.281 12.6204C7.26384 12.6817 7.22711 12.7357 7.17639 12.7742C7.12568 12.8127 7.06377 12.8335 7.00012 12.8335C6.93647 12.8335 6.87456 12.8127 6.82385 12.7742C6.77314 12.7357 6.7364 12.6817 6.71925 12.6204L5.797 9.04166Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 1.75V4.08333",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.91667H10.5",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33398 9.91667V11.0833",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 10.5H1.75",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardstar);
export default __webpack_public_path__ + "static/media/dashboard star.6d0d04d613636a2a462988233a784b56.svg";
export { ForwardRef as ReactComponent };